export const HIRE_CHECKS = [
    { key: "phv", label: "Licensed for Private Hire", always: true },
    {
        key: "insurance",
        label: "Insurance included in weekly price",
        field: "insuranceIncluded",
        value: true,
    },
    { key: "mot", label: "MOT & servicing included", always: true },
    { key: "breakdown", label: "Breakdown cover", always: true },
    { key: "tax", label: "Road tax included", always: true },
    { key: "licence", label: "Valid PHV driver licence required", note: true },
]

export const buildHireChecks = (vehicle) =>
    HIRE_CHECKS.map((check) => {
        if (check.always) return { ...check, passed: true }
        if (check.note) return { ...check, passed: null }
        if (check.field === "insuranceIncluded") {
            const withPkg = vehicle.hirePackages?.withInsurance
            const withoutPkg = vehicle.hirePackages?.withoutInsurance
            if (withPkg && withoutPkg) {
                return {
                    ...check,
                    passed: true,
                    label: "Insurance optional — choose with or without",
                }
            }
            if (withPkg) {
                return {
                    ...check,
                    passed: true,
                    label: "Insurance included in weekly price",
                }
            }
            if (withoutPkg) {
                return {
                    ...check,
                    passed: false,
                    label: "Insurance not included — arrange with our team",
                }
            }
            return {
                ...check,
                passed: vehicle.insuranceIncluded,
                label: vehicle.insuranceIncluded
                    ? "Insurance included in weekly price"
                    : "Insurance not included — arrange with our team",
            }
        }
        return { ...check, passed: false }
    })
